import { Flex, PageTitle, Tag } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { DiscriminatedInspectionEvaluationModel } from '@/features/project/projects/_models/project';
import { useId } from '@/hooks';
import { isPS } from '@/utils';
import { ReviewTypeLabelModifier } from '@/utils/enum';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ProjectNameTitle: FC = () => {
  const { t } = useTranslation();
  const { id } = useId();
  const project = useProject(id);
  const parsed = DiscriminatedInspectionEvaluationModel.safeParse(project.data);
  const reviewTypeText = useMemo(() => {
    if (isPS() || !parsed.success || parsed.data.sheetType !== 'RS') {
      return;
    }
    const reviewType =
      parsed.data.inspectionEvaluation.inspectionByExternalExpert?.reviewType;
    if (reviewType === 'document' || reviewType === 'public-process') {
      return ReviewTypeLabelModifier[reviewType];
    }
  }, [parsed]);

  return (
    <Flex align="center" gap={16}>
      <PageTitle text={project.data?.name ?? ''} />
      {reviewTypeText !== undefined && (
        <Tag>{t('is-target-review-type', { reviewType: reviewTypeText })}</Tag>
      )}
    </Flex>
  );
};
